<template>
  <div class="row spinning-wheel-report">
    <div class="col-xl-12 col-md-12 col-xs-12">
      <div class="card mar-to-15 tableInvoice">
        <div class="card-content">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>

          <div class="table-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px; flex-wrap: wrap;">
            <div class="left-group" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-end; flex: 1 1 auto;">
              <div class="form-group" style="margin: 0;">
                <label>{{ $t('reports.dateInterval') }}</label>
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  format="dd/MM/yyyy"
                  size="small"
                  style="width: 260px;"
                />
              </div>
              <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                <button class="btn add" @click="applyFilters" :title="$t('reports.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                  <i class="ti-search"></i> {{ $t('general.search') }}
                </button>
              </div>
            </div>
          </div>

          <div class="data-table" style="margin-top: 20px;">
            <el-table
              :data="tableData"
              :empty-text="$t('gestiune.noData')"
              style="width: 100%;"
              @row-click="onRowClick"
            >
              <el-table-column prop="id" :label="$t('customers.id')" width="80" />
              <el-table-column prop="title" :label="$t('spinningWheel.campaignTitle')" min-width="160" show-overflow-tooltip />
              <el-table-column :label="$t('spinningWheel.active')" width="90">
                <template slot-scope="props">
                  {{ props.row.active ? $t('general.yes') : $t('general.no') }}
                </template>
              </el-table-column>
              <el-table-column prop="spins" :label="$t('spinningWheel.spins')" width="90" />
              <el-table-column prop="users_who_spun" :label="$t('spinningWheel.usersWhoSpun')" width="120" />
              <el-table-column prop="rewards_won" :label="$t('spinningWheel.rewardsWon')" width="120" />
              <el-table-column prop="rewards_redeemed" :label="$t('spinningWheel.rewardsRedeemed')" width="130" />
              <el-table-column :label="$t('spinningWheel.redemptionRate')" width="120">
                <template slot-scope="props">
                  {{ props.row.redemption_rate != null ? props.row.redemption_rate + '%' : '—' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { DatePicker, Table, TableColumn } from 'element-ui'

Vue.use(DatePicker)
Vue.use(Table)
Vue.use(TableColumn)

export default {
  props: {
    isSpinningWheelReport: { type: Boolean, default: false }
  },
  data () {
    return {
      loading: false,
      dateRange: [],
      tableData: []
    }
  },
  watch: {
    isSpinningWheelReport (active) {
      if (active) this.loadReport()
    }
  },
  mounted () {
    if (this.isSpinningWheelReport) this.loadReport()
    this.$bus.$on('refresh-spinning-wheel-report', this.loadReport)
  },
  beforeDestroy () {
    this.$bus.$off('refresh-spinning-wheel-report', this.loadReport)
  },
  methods: {
    applyFilters () {
      this.loadReport()
    },
    buildParams () {
      const params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      if (this.dateRange && this.dateRange[0]) params.date_from = this.dateRange[0]
      if (this.dateRange && this.dateRange[1]) params.date_to = this.dateRange[1]
      return params
    },
    loadReport () {
      this.loading = true
      this.apiRequest('/reports/spinning-wheel', 'GET', this.buildParams(), (response) => {
        this.loading = false
        if (response.status && response.data) {
          this.tableData = Array.isArray(response.data) ? response.data : []
        } else {
          this.tableData = []
        }
      })
    },
    onRowClick (row) {
      if (!row || !row.id) return
      this.$router.push({
        path: '/reports/spinning-wheel/' + row.id + '/rewards',
        query: {
          title: row.title || ('#' + row.id),
          date_from: (this.dateRange && this.dateRange[0]) || '',
          date_to: (this.dateRange && this.dateRange[1]) || ''
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/SpinningWheelReport.vue